module.exports = __webpack_public_path__ + "img/img21.6302c8ae.png";